import { motion } from "framer-motion";
import { MapPin, CurrencyDollar, CalendarCheck } from "@phosphor-icons/react";

const steps = [
  {
    icon: MapPin,
    title: "1. Request Your Offer",
    text: "Tell us about your property by phone or the quick form. It takes less than 2 minutes.",
  },
  {
    icon: CurrencyDollar,
    title: "2. Get an All-Cash Offer",
    text: "Receive a fair, no-obligation cash offer within 24 hours. No lowball surprises.",
  },
  {
    icon: CalendarCheck,
    title: "3. Close & Get Paid",
    text: "Pick your closing date — as fast as 7 days — and walk away with cash in hand.",
  },
];

export const HowItWorks = () => (
  <section
    id="how-it-works"
    data-testid="how-it-works-section"
    className="bg-white py-20 md:py-32 px-6 md:px-12 lg:px-16"
  >
    <div className="max-w-7xl mx-auto">
      <div className="text-center max-w-2xl mx-auto">
        <span className="uppercase text-xs md:text-sm tracking-[0.2em] font-semibold text-emerald-700">
          Simple & Stress-Free
        </span>
        <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
          Our Simple 3-Step Process
        </h2>
        <p className="mt-4 text-base md:text-lg text-slate-600">
          Selling your home shouldn't be complicated — especially when you're going through a tough time.
        </p>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
        {steps.map((s, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            data-testid={`how-step-${i + 1}`}
            className="bg-stone-50 p-8 rounded-2xl border border-stone-100 hover:-translate-y-1 hover:shadow-lg transition-all"
          >
            <div className="h-14 w-14 rounded-xl bg-emerald-100 flex items-center justify-center">
              <s.icon weight="duotone" className="h-7 w-7 text-emerald-600" />
            </div>
            <h3 className="font-heading mt-6 text-xl font-semibold text-slate-900">{s.title}</h3>
            <p className="mt-3 text-slate-600 leading-relaxed">{s.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
